import UseContext from 'hooks/useContext';
import { useCallback } from 'react';

// The slide-over of an appointment (components/SlideOver/dataSlideOver).
export const APPOINTMENT_PANEL = 'get_appointment';

// Opens an appointment's panel: the slide-over reads its id in `objID`;
// `edit`: straight on its form (« Reporter » of a record's next action).
const useAppointmentPanel = () => {
  const { setObjID, setSlideOverType, setSlideOverShow } = UseContext();
  const openAppointment = useCallback(
    (id, { edit = false } = {}) => {
      setObjID(edit ? { appointmentId: id, edit: true } : id);
      setSlideOverType(APPOINTMENT_PANEL);
      setSlideOverShow(true);
    },
    [setObjID, setSlideOverType, setSlideOverShow],
  );
  return { openAppointment };
};

export default useAppointmentPanel;
